exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avatar-uploader .el-upload[data-v-5cb15d02]{border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.avatar-uploader .el-upload[data-v-5cb15d02]:hover{border-color:#409eff}.avatar-uploader-icon[data-v-5cb15d02]{font-size:28px;color:#8c939d;width:100px;height:100px;line-height:100px;text-align:center}.avatar[data-v-5cb15d02]{width:100px;height:100px;display:block}.avatar-wrapper[data-v-5cb15d02]{margin-top:5px;position:relative}.avatar-wrapper .user-avatar[data-v-5cb15d02]{width:40px;height:40px;border-radius:10px}\n", ""]);

// exports
